import type { JobsData } from '../_components/types';

const BASE_LOCATION_URL =
  'https://apply.workable.com/api/v1/widget/accounts/327276?location=';

export const getJobsByLocation = async (
  location: string,
): Promise<JobsData | undefined> => {
  const url = `${BASE_LOCATION_URL}${location}`;
  return fetch(url)
    .then((res) => res.json() as Promise<JobsData>)
    .catch(() => {
      // log to datadog
      return undefined;
    });
};
